import React from 'react';
import { IconProps } from '../IconProps';
const SvgChart = ({
  primaryColor,
  secondaryColor,
  tertiaryColor,
  ...props
}: IconProps) => (
  <svg width="1em" height="1em" viewBox="0 0 18 18" fill="none" {...props}>
    <path
      d="M9.25 2h-.5A1.75 1.75 0 007 3.75v10.5c0 .966.784 1.75 1.75 1.75h.5A1.75 1.75 0 0011 14.25V3.75A1.75 1.75 0 009.25 2zM3.75 7h-.5A1.75 1.75 0 001.5 8.75v5.5c0 .966.784 1.75 1.75 1.75h.5a1.75 1.75 0 001.75-1.75v-5.5A1.75 1.75 0 003.75 7zM14.75 11h-.5a1.75 1.75 0 00-1.75 1.75v1.5c0 .966.784 1.75 1.75 1.75h.5a1.75 1.75 0 001.75-1.75v-1.5A1.75 1.75 0 0014.75 11z"
      fill={primaryColor}
    />
  </svg>
);
export default SvgChart;
